import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export const TrainingAgencyPage = () => (
  <>
    <Helmet>
      <title>Agency Training - AutoScript</title>
    </Helmet>
    <Header title="Agency Training" backRoute={routes.training.make()} />

    <main className="px-4 md:px-[30px] pt-2 pb-[70px] max-w-[860px]">
      <h2 className="text-xl font-semibold text-[var(--color-text)] m-0">Agency Training Course</h2>
      <p className="mt-3 mb-4 text-sm leading-[150%] text-[var(--color-text-muted)]">
        Explore the distinctive features within our platform for seamless workflow management. Our specialized training
        course offers in-depth tutorials, guiding you through the utilization of tools for overseeing the transcription
        job process, effectively organizing tasks using our repository (Cases), and efficiently managing your team
        members.
      </p>
      <p className="mt-0 mb-6 text-sm leading-[150%] text-[var(--color-text-muted)]">
        Elevate your organizational efficiency with our comprehensive solution for court reporting and transcription.
        This end-to-end platform facilitates effortless collaboration not only within your team but also with the
        professionals you choose to work with.
      </p>
      <Link to={routes.trainingFolder.make('Agency', 'Agency')} className="btn">
        Let&apos;s Get Started
      </Link>
    </main>
  </>
);
